import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useInvoiceFooterUpdate = () => {
  const [loading, setLoading] = useState(false);
  const updateInvoice = async (data) => {
    // Update invoice footer
    setLoading(true);
    try {
      const response = await apiService.updateInvoiceFooter(data);
      return response;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    updateInvoice,
  };
};
